import { OxCategoriesNames } from '@oxappsec/ox-consolidated-categories';

// TODO: If anyone actually uses this file, please tell Yaniv so he can move this entire map to the lib :)
export const topIssuesToolTipInfo = new Map<string, string>([
  [
    OxCategoriesNames.ArtifactsIntegrity,
    'These are the most important issues that need to be addressed in order to secure your supply chain',
  ],
  [
    OxCategoriesNames.SBOM,
    'These are the most important open source library issues that are NOT related to known vulnerabilities',
  ],
  [
    OxCategoriesNames.DevProccess,
    'These are the most important issues related to coding and development processes',
  ],
  ['Secrets', 'These are the most important secrets/tokens/passwords found'],
  [
    OxCategoriesNames.CodeSecurity,
    'These are the most important static code security issues found',
  ],
  [
    OxCategoriesNames.OpenSourceSecurity,
    'These are the most important vulnerabilities found in the utilized open source libraries',
  ],
  ['CI/CD', 'These are the most important issues found related to CI/CD'],
  [
    OxCategoriesNames.SecurityToolsCoverage,
    'These are the most important issues found related to security tool code coverage',
  ],
  [
    OxCategoriesNames.IaC,
    'These are the most important Infrastructure as Code issues found',
  ],
  [
    OxCategoriesNames.ContainerSecurity,
    'These are the most important issues found related to artifacts and containers',
  ],
  [
    OxCategoriesNames.CloudSecurity,
    'These are the most important issues found related to Cloud Security Posture Management',
  ],
]);
